import { render, staticRenderFns } from "./SelectedFlightListItemSlots.vue?vue&type=template&id=63c6547b&scoped=true"
import script from "./SelectedFlightListItemSlots.vue?vue&type=script&lang=js"
export * from "./SelectedFlightListItemSlots.vue?vue&type=script&lang=js"
import style0 from "./SelectedFlightListItemSlots.vue?vue&type=style&index=0&id=63c6547b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6547b",
  null
  
)

export default component.exports